/* eslint-disable no-param-reassign */
import brandService from "src/services/brandService";

export const GET_LIST_BRAND_REQUEST = "@brand/get-list-brand-request";
export const GET_LIST_BRAND_SUCCESS = "@brand/get-list-brand-success";
export const GET_LIST_BRAND_FAILURE = "@brand/get-list-brand-failure";

export const GET_BRAND_REQUEST = "@brand/get-brand-request";
export const GET_BRAND_SUCCESS = "@brand/get-brand-success";
export const GET_BRAND_FAILURE = "@brand/get-brand-failure";

export const ADD_BRAND_REQUEST = "@brand/add-brand-request";
export const ADD_BRAND_SUCCESS = "@brand/add-brand-success";
export const ADD_BRAND_FAILURE = "@brand/add-brand-failure";

export const UPDATE_BRAND_REQUEST = "@brand/udpate-brand-request";
export const UPDATE_BRAND_SUCCESS = "@brand/udpate-brand-success";
export const UPDATE_BRAND_FAILURE = "@brand/udpate-brand-failure";

export const DELETE_BRAND_REQUEST = "@brand/delete-brand-request";
export const DELETE_BRAND_SUCCESS = "@brand/delete-brand-success";
export const DELETE_BRAND_FAILURE = "@brand/delete-brand-failure";

export const GET_LIST_BRAND_TYPE_REQUEST = "@brand/get-list-brand-type-request";
export const GET_LIST_BRAND_TYPE_SUCCESS = "@brand/get-list-brand-type-success";
export const GET_LIST_BRAND_TYPE_FAILURE = "@brand/get-list-brand-type-failure";

export const CLEAR_BRAND = "@brand/clear-brand";
export const CLEAR_LIST_BRAND = "@brand/clear-list-brand";

export function getListBrand(data = {}) {
  return async (dispatch) => {
    try {
      dispatch({type: GET_LIST_BRAND_REQUEST});
      const response = await brandService.getListBrand(data);
      dispatch({
        type: GET_LIST_BRAND_SUCCESS,
        payload: {
          response: response.data.data,
          total: response.headers["x-total-items"]
        }
      });
    } catch (error) {
      dispatch({type: GET_LIST_BRAND_FAILURE});
      throw error;
    }
  };
}

export function getBrand(id) {
  return async (dispatch) => {
    try {
      dispatch({type: GET_BRAND_REQUEST});
      const response = await brandService.getBrand(id);
      dispatch({
        type: GET_BRAND_SUCCESS,
        payload: {
          response
        }
      });
    } catch (error) {
      dispatch({type: GET_BRAND_FAILURE});
      throw error;
    }
  };
}

export function addBrand(data) {
  return async (dispatch) => {
    try {
      dispatch({type: ADD_BRAND_REQUEST});
      const response = await brandService.createBrand(data);
      dispatch({
        type: ADD_BRAND_SUCCESS,
        payload: {
          response
        }
      });
    } catch (error) {
      dispatch({type: ADD_BRAND_FAILURE});
      throw error;
    }
  };
}

export function updateBrand(data) {
  return async (dispatch) => {
    try {
      dispatch({type: UPDATE_BRAND_REQUEST});
      const response = await brandService.updateBrand(data);
      dispatch({
        type: UPDATE_BRAND_SUCCESS,
        payload: {
          response
        }
      });
    } catch (error) {
      dispatch({type: UPDATE_BRAND_FAILURE});
      throw error;
    }
  };
}

export function deleteBrand(id) {
  return async (dispatch) => {
    try {
      dispatch({type: DELETE_BRAND_REQUEST});
      const response = await brandService.deleteBrand(id);
      dispatch({
        type: DELETE_BRAND_SUCCESS,
        payload: {
          response
        }
      });
    } catch (error) {
      dispatch({type: DELETE_BRAND_FAILURE});
      throw error;
    }
  };
}

export function getListBrandType() {
  return async (dispatch) => {
    try {
      dispatch({type: GET_LIST_BRAND_TYPE_REQUEST});
      const response = await brandService.getListBrandType();
      dispatch({
        type: GET_LIST_BRAND_TYPE_SUCCESS,
        payload: {
          response
        }
      });
    } catch (error) {
      dispatch({type: GET_LIST_BRAND_TYPE_FAILURE});
      throw error;
    }
  };
}

export function clearBrand() {
  return async (dispatch) => {
    dispatch({
      type: CLEAR_BRAND
    });
  };
}

export function clearListBrand() {
  return async (dispatch) => {
    dispatch({
      type: CLEAR_LIST_BRAND
    });
  };
}
